export default {
  'projects.researchAssistant.titleApp': 'Research Assistant',
  'projects.researchAssistant.titleYou': 'You',
  'projects.researchAssistant.updateInfoMessage': 'You updated the cohort definition',

  'projects.researchAssistant.chatWindow.title': 'Research Assistant (beta)',
  'projects.researchAssistant.chatWindow.modelDropdown.label': 'Version',
  'projects.researchAssistant.chatWindow.inputField.placeholder.isOwner': 'Enter a prompt...',
  'projects.researchAssistant.chatWindow.inputField.placeholder.isNotOwner':
    'Only the cohort owner can submit messages.',
  'projects.researchAssistant.chatWindow.inputField.placeholder.invalidStatus':
    'Cohort is not in a valid state for messaging.',
  'projects.researchAssistant.chatWindow.inputField.placeholder.raNotReady':
    'Research Assistant is not ready for messaging.',

  'projects.researchAssistant.footer.disclaimer':
    'Research Assistant may make mistakes. Double-check all output.',
};
